import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="bg-white border-t border-border mt-20 pb-24 md:pb-0" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="flex flex-col md:flex-row justify-between gap-8">
                    <div className="space-y-3">
                        <img src="/logo-youvibeticket-clr.png" alt="youvibeticket" className="h-10 w-auto" />
                        <p className="text-sm text-muted-foreground max-w-xs">
                            {t("brand.tagline")}
                        </p>
                    </div>
                    <div className="flex flex-wrap gap-6 md:gap-10 text-sm font-semibold">
                        <Link to="/about" className="hover:text-muted-foreground">{t("footer.about")}</Link>
                        <Link to="/contact" className="hover:text-muted-foreground">{t("footer.contact")}</Link>
                        <Link to="/terms" className="hover:text-muted-foreground">{t("footer.terms")}</Link>
                        <Link to="/privacy" className="hover:text-muted-foreground">{t("footer.privacy")}</Link>
                        <Link to="/refund-policy" className="hover:text-muted-foreground">{t("footer.refund")}</Link>
                    </div>
                </div>
                <div className="mt-10 pt-6 border-t border-border text-xs text-muted-foreground">
                    © {new Date().getFullYear()} youvibeticket. {t("footer.rights")}.
                </div>
            </div>
        </footer>
    );
};
